module.exports = __webpack_public_path__ + "img/copy-field.b1366032.svg";